import styled, { type CSSProperties } from 'styled-components'

type Props = {
	textAlign?: CSSProperties['textAlign']
}

export const Header = styled.div<Props>`
	text-align: ${({ textAlign = 'left' }) => textAlign};
	margin-bottom: 16px;
`
